/**
 * Index of Relative Rurality (IRR) — county-level lookup.
 * Generated by data_raw/build_irr.R from the Kim & Waldorf 2020 county data.
 *
 * Value: continuous 0–1 index (higher = more rural), an equal-weight composite
 * of population, density, remoteness, and built-up area. Display/comparison
 * only — NOT a composite input for this app.
 *
 * Source:  Kim, A., & Waldorf, B. (2023). The Index of Relative Rurality (IRR):
 *          US County Data for 2020 (Version 1.0.0) [Data set]. Zenodo.
 *          https://doi.org/10.5281/zenodo.7675745
 * License: CC BY 4.0 — values reformatted to JSON (a modification, noted per
 *          the license). NOT the AppalTRUST reconstruction (different terms).
 */

let _data = null;
let _loadPromise = null;

export function loadIrrData() {
  if (_data) return Promise.resolve();
  if (_loadPromise) return _loadPromise;
  _loadPromise = fetch(`${process.env.PUBLIC_URL}/data/irr.json`)
    .then(r => {
      if (!r.ok) throw new Error(`Failed to load IRR data (${r.status})`);
      return r.json();
    })
    .then(d => { _data = d; _loadPromise = null; })
    .catch(err => { _loadPromise = null; throw err; });
  return _loadPromise;
}

export function getIRRForCounty(stateFips, countyFips) {
  if (!_data) return null;
  const key = `${String(stateFips).padStart(2, "0")}${String(countyFips).padStart(3, "0")}`;
  const v = _data[key];
  return typeof v === "number" ? v : null;
}

const irr = { loadIrrData, getIRRForCounty };
export default irr;
